import { ControlType, FetchStatus, Property } from "../../../../../base/types";
import { DateProperties, useDateProperties } from "./DateProperties";
import { ErrorMessage, Spinner } from "../../../../../widgets";
import { FC, useCallback } from "react";

import { DateDraftComponent } from "./DateDraftComponent";
import { DateField } from "./DateField";
import { IControlAttributes } from "../../../../../base/models";
import { InputLabel } from "../../InputLabel";
import { Registry } from "../../../../../base/register";
import { SimpleDate } from "./SimpleDate";

export const DateComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = useDateProperties(props);
    const { label, required, title } = properties || {}
    const containerClass = label ? className : ''
    const inputClass = label ? '' : className

    const getDateInput = useCallback(() => {
        const binding = bindings?.getBinding(Property.InitValue);
        switch (binding?.type) {
            case "Field":
                return <DateField
                    id={control.controlId}
                    title={title}
                    name={binding.boundValue}
                    {...properties}
                    className={inputClass}
                />
            case "Const":
            case "Expression":
            default:
                return <SimpleDate
                    id={control.controlId}
                    title={title}
                    {...properties}
                    value={binding?.value}
                    className={inputClass}
                />
        }

        // eslint-disable-next-line
    }, [properties, bindings, control])


    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <InputLabel
        htmlFor={control.controlId}
        title={title}
        label={label}
        required={required}
        className={containerClass}>
        {getDateInput()}
    </InputLabel>
}

Registry.addControl({
    id: "1893467f-2312-48a2-a999-648da73ffce2",
    name: "Date Input",
    type: ControlType.Date,
    properties: DateProperties,
    component: DateComponent,
    draftComponent: DateDraftComponent
})
